import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../_services/user.service";
import { Observable } from "rxjs/Rx";
import { Utils } from "../../utils";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router, private _userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {



        if (state.url == "/utente" || state.url == "utente") {
            return true;
        }

        return this._userService.verify().map(

            data => {

                if (data.response == 0) {
                    // logged in so return true

                    return true;
                }
                // error when verify so redirect to login page with the return url
                this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
            // ,
            // error => {

            //Utils.log("varify error",error);
            //     // error when verify so redirect to login page with the return url
            //     this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            //     return Observable.of(false);
            // });

        ).catch(() => {
            this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return Observable.of(false);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_guards/auth.guard.ts